export type UserProfileRole = string | string[];
export const CUSTOMER_LOGIN_TYPE = "A";
export const CONSIGNEE_LOGIN_TYPE = "B";
export const CARRIER_LOGIN_TYPE = "C";
export const ABECASUSER_LOGIN_TYPE = "D";
export const disableTransDate = (r: UserProfileRole) => {
    let loginTypes: string[] = [];
    if (r === undefined || r === null) {
        loginTypes.push(CUSTOMER_LOGIN_TYPE);
    } else {

        if (Array.isArray(r)) {
            loginTypes = r;
        } else {
            loginTypes.push(r as string);
        }
    }

    if (
        loginTypes.findIndex(rr => rr === ABECASUSER_LOGIN_TYPE) > -1) {
        return false;
    }
    return loginTypes.findIndex(rr => rr === CARRIER_LOGIN_TYPE
        || rr === CONSIGNEE_LOGIN_TYPE
        || rr === CUSTOMER_LOGIN_TYPE) > -1
}